import React                      from 'react';
import PropTypes                  from 'prop-types';
import { useTranslation }         from 'react-i18next';
import useStyles                  from './styles';

import clsx                       from 'clsx';
import Paper                      from '~/components/Paper';
import ErrorOutline               from '@material-ui/icons/ErrorOutline';
import List                       from '@material-ui/core/List';
import ListItem                   from '@material-ui/core/ListItem';
import Grid                       from '@material-ui/core/Grid';

import blueCircle                 from '~/assets/images/circle-blue.png';
import greenCircle                from '~/assets/images/circle-green.png';
import redCircle                  from '~/assets/images/circle-red.png';
import yellowCircle               from '~/assets/images/circle-yellow.png';
import EventRecord                  from '~/records/EventRecord';

function EventEvents({loading, record}) {
  const classes = useStyles();
  const { t } = useTranslation();

  const trAttr = (attr) => t(`person.routes.${attr}`);

  return (
    <Paper
      Icon={ErrorOutline}
      title={t('event.extras.events_title')}
      loading={loading}
      iconColor='purple'
    >
      <Grid container>
        <Grid item md={6} xs={12}>
          <List nopadding="true" className={clsx(classes.LeftTab, classes.padding)}>
            <ListItem divider disableGutters>{<img src={blueCircle} height={20} width={20} style={{marginRight: 10, marginLeft:4}}/>}{trAttr('cell_phone_usage')} {record.get('use_phone_count')}</ListItem>
            <ListItem divider disableGutters>{<img src={greenCircle} height={20} width={20} style={{marginRight: 10, marginLeft:4}}/>}{trAttr('fast_acceleration')}{record.get('fast_acceleration_count')}</ListItem>
          </List>
        </Grid>
        <Grid item md={6} xs={12}>
          <List nopadding="true" className={clsx(classes.RightTab, classes.padding)}>
            <ListItem divider disableGutters>{<img src={redCircle} height={20} width={20} style={{marginRight: 10, marginLeft:4}}/>}{trAttr('abrupt_braking')} {record.get('abrupt_braking_count')}</ListItem>
            <ListItem divider disableGutters>{<img src={yellowCircle} height={20} width={20} style={{marginRight: 10, marginLeft:4}}/>}{trAttr('high_speed')} {record.get('high_speed_count')}</ListItem>
          </List>
        </Grid>
      </Grid>
    </Paper>
  );
}

EventEvents.propTypes={
  loading: PropTypes.bool.isRequired,
  record: PropTypes.instanceOf(EventRecord).isRequired,
};

export default EventEvents;
